import React, { Component, Suspense } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
// import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import "antd/dist/antd.less"; //importing from less because of customised theme
import "./custom.css";
import "./styles/design-system.css";
import "./styles/gradient-buttons.css";
import "./Layouts/sidebar.css";
import "./Layouts/layout.css";
import "./components/Layout/ScreenLayout.css";
import "./components/Topbar.css";
import "./styles/kuber-v2.css";
import "./styles/legacy-screens-modern.css";
import store, { history } from "./store";
import Loader from "Layouts/Loader";
import PrivateRoute from "./PrivateRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import CacheBuster from "components/cacheBuster";
import PageNotFound from "Screens/PageNotFound";
import { KaiContextProvider } from "components/KaiSidekick/KaiContext";
import { ImageStudioProvider } from "components/ImageStudio/ImageStudioContext";
import KaiSidekickPanel from "components/KaiSidekick/KaiSidekickPanel";
import KaiScreenContextBridge from "components/KaiSidekick/KaiScreenContextBridge";
import KaiGlobalCatalogBridge from "components/KaiSidekick/KaiGlobalCatalogBridge";
import SetupGuide from "components/SetupGuide/SetupGuide";
import { SetupProgressProvider } from "components/SetupGuide/SetupProgressContext";
const loginPage = React.lazy(() => import("Screens/Login/Login"));
const signupPage = React.lazy(() => import("Screens/Signup/Signup"));
const forgotPasswordPage = React.lazy(() =>
  import("Screens/ForgotPassword/ForgotPassword")
);
const resetPasswordPage = React.lazy(() =>
  import("Screens/ResetPassword/ResetPassword")
);

const settingsPage = React.lazy(() => import("./Screens/Settings"));
const settingsLegacyRedirect = React.lazy(() =>
  import("./Screens/Settings").then((m) => ({ default: m.SettingsLegacyRedirect }))
);
const EmailNotificationTemplates = React.lazy(() =>
  import("Screens/Settings/EmailNotifications/EmailNotificationTemplates")
);
const StripeConnectOAuthCallback = React.lazy(() =>
  import(
    "Screens/Settings/ThirdPartyToolsSettings/StripeConnectOAuthCallback"
  )
);
const AddShippingRule = React.lazy(() =>
  import("Screens/Settings/ShippingSettings/AddNewRule")
);
const Dashboard = React.lazy(() => import("Screens/Dashboard/Dashboard"));
const UserList = React.lazy(() => import("Screens/Users/UserList"));

const AddUser = React.lazy(() => import("Screens/Users/AddUser"));

const UserRole = React.lazy(() => import("Screens/Users/UserRole"));
const AddUserRole = React.lazy(() => import("Screens/Users/AddUserRole"));
const ProductsList = React.lazy(() =>
  import("Screens/Catalogue/Products/ProductsList")
);
// const AddProduct = React.lazy(() =>
//   import("Screens/Catalogue/Products/AddProduct")
// );
const BrandsList = React.lazy(() =>
  import("Screens/Catalogue/Brands/BrandsList")
);
const AddBrand = React.lazy(() => import("Screens/Catalogue/Brands/AddBrand"));

const SupplierList = React.lazy(() =>
  import("Screens/Catalogue/Suppliers/SuppliersList")
);
const AddSupplier = React.lazy(() =>
  import("Screens/Catalogue/Suppliers/AddSupplier")
);
const StoreList = React.lazy(() =>
  import("Screens/Catalogue/Stores/StoreList")
);
const AddStore = React.lazy(() => import("Screens/Catalogue/Stores/AddStore"));

const AttributeList = React.lazy(() =>
  import("Screens/Catalogue/Attributes/AttributesList")
);
const AddAttribute = React.lazy(() =>
  import("Screens/Catalogue/Attributes/AddAttribute")
);

const CategoryList = React.lazy(() =>
  import("Screens/Catalogue/Categories/CategoriesList")
);
const AddCategory = React.lazy(() =>
  import("Screens/Catalogue/Categories/AddCategory")
);

const EditProduct = React.lazy(() =>
  import("Screens/Catalogue/Products/EditProduct/EditProduct")
);

const OrderList = React.lazy(() => import("Screens/Orders/OrderListTab"));

const OrderDetails = React.lazy(() =>
  import("Screens/Orders/OrderDetails/Index")
);

const OrderInvoices = React.lazy(() =>
  import("Screens/Orders/OrderInvoices/Invoices")
);

const EditVariantPage = React.lazy(() =>
  import(
    "Screens/Catalogue/Products/CreateProduct/CreateVariant/Componants/EditVariant"
  )
);
const AddContentPage = React.lazy(() =>
  import("Screens/Contents/Pages/AddPage")
);
const ContentPageList = React.lazy(() =>
  import("Screens/Contents/Pages/ContentPagesList")
);
const AddNewsPage = React.lazy(() => import("Screens/Contents/News/AddNews"));

const AddNewsCategory = React.lazy(() =>
  import("Screens/Contents/News/AddNewCategory")
);

const ContentNewsList = React.lazy(() =>
  import("Screens/Contents/News/ContentNewsList")
);

const InventoryList = React.lazy(() =>
  import("Screens/Catalogue/Inventory/InventoryList")
);
const MediaGallery = React.lazy(() => import("Screens/Media/MediaGallery"));
const TemplateList = React.lazy(() =>
  import("Screens/WebsiteTemplate/Templates")
);
const TemplateData = React.lazy(() =>
  import("Screens/WebsiteTemplate/TemplateData")
);
const CouponsList = React.lazy(() => import("Screens/Coupons/CouponsList"));

const AddCouponsPage = React.lazy(() => import("Screens/Coupons/CouponForm"));

const GeneralReport = React.lazy(() => import("Screens/Report/General"));

const CustomersList = React.lazy(() =>
  import("Screens/Customers/CustomersList")
);

const NewcustomerForm = React.lazy(() =>
  import("Screens/Customers/NewcustomerForm")
);

const Reviews = React.lazy(() => import("Screens/Customers/Reviews"));

const ReviewsDetail = React.lazy(() =>
  import("Screens/Customers/ReviewsDetail")
);
const CustomersDetail = React.lazy(() =>
  import("Screens/Customers/CustomersDetail")
);

const ImportCSV = React.lazy(() =>
  import("Screens/Catalogue/Import/ImportCSV")
);
const ExcelImport = React.lazy(() =>
  import("Screens/Catalogue/Import/ImportExcelFile")
);

const IntroductionGuide = React.lazy(() =>
  import("Screens/IntroductionGuide/IntroductionGuide")
);

export default class App extends Component {
  render() {
    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          // Add null check for refreshCacheAndReload function
          if (!loading && !isLatestVersion && refreshCacheAndReload) {
            // You can decide how and when you want to force reload
            refreshCacheAndReload();
          }

          return (
            <Provider store={store}>
              <ConnectedRouter history={history}>
                <KaiContextProvider>
                <ImageStudioProvider>
                <KaiScreenContextBridge />
                <KaiGlobalCatalogBridge />
                <SetupProgressProvider>
                <ErrorBoundary>
                  <Suspense fallback={<Loader />}>
                    <Switch>
                      {/* Login Routes */}
                      <Route exact path="/" component={loginPage} />
                      <Route exact path="/signup" component={signupPage} />
                      {/* Forgotpassword Routes */}
                      <Route
                        exact
                        path="/forgot"
                        component={forgotPasswordPage}
                      />
                      {/* Resetpassword Routes */}
                      <Route
                        exact
                        path="/resetpasswordwithtoken/"
                        component={resetPasswordPage}
                      />
                      {/* Dashboard Routes */}
                      <PrivateRoute
                        exact
                        path="/dashboard"
                        component={Dashboard}
                      />
                      {/* User Routes */}
                      <PrivateRoute
                        exact
                        path="/user/list"
                        component={UserList}
                      />
                      <PrivateRoute
                        exact
                        path="/user/add"
                        component={AddUser}
                      />
                      <PrivateRoute
                        exact
                        path="/user/edit/:id"
                        component={AddUser}
                      />
                      {/* User Role Routes */}
                      <PrivateRoute
                        exact
                        path="/user/role"
                        component={UserRole}
                      />
                      <PrivateRoute
                        exact
                        path="/user/role/add"
                        component={AddUserRole}
                      />
                      {/* Product Routes */}
                      <PrivateRoute
                        exact
                        path="/catalogue/products"
                        component={ProductsList}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/products/add"
                        component={EditProduct}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/products/edit/:id"
                        component={EditProduct}
                      />
                      {/* Brand Routes */}
                      <PrivateRoute
                        exact
                        path="/catalogue/brands"
                        component={BrandsList}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/brands/add"
                        component={AddBrand}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/brands/edit/:id"
                        component={AddBrand}
                      />
                      <PrivateRoute
                        exact
                        path="/setting/shipping/add"
                        component={AddShippingRule}
                      />
                      <PrivateRoute
                        exact
                        path="/setting/shipping/:id"
                        component={AddShippingRule}
                      />
                      {/* Suppliers Routes */}
                      <PrivateRoute
                        exact
                        path="/catalogue/suppliers"
                        component={SupplierList}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/suppliers/add"
                        component={AddSupplier}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/suppliers/edit/:id"
                        component={AddSupplier}
                      />
                      {/* Store Routes */}
                      <PrivateRoute
                        exact
                        path="/catalogue/stores"
                        component={StoreList}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/stores/add"
                        component={AddStore}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/stores/edit/:id"
                        component={AddStore}
                      />
                      {/* Settings - unified one-pager; legacy paths redirect with hash */}
                      <PrivateRoute
                        exact
                        path="/settings"
                        component={settingsPage}
                      />
                      <PrivateRoute
                        exact
                        path="/stripe-connect/oauth-callback"
                        component={StripeConnectOAuthCallback}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/general"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/emailnotifications"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/emailnotifications/customer/:type"
                        component={EmailNotificationTemplates}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/emailnotifications/staff/:type"
                        component={EmailNotificationTemplates}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/tools"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/orders"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/invoices"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/legal"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/store"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/selling"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/taxes"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/shipping"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/product"
                        component={settingsLegacyRedirect}
                      />
                      <PrivateRoute
                        exact
                        path="/settings/domain"
                        component={settingsLegacyRedirect}
                      />
                      {/* Attributes Routes */}
                      <PrivateRoute
                        exact
                        path="/catalogue/attributes"
                        component={AttributeList}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/attribute/add"
                        component={AddAttribute}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/attribute/edit/:id"
                        component={AddAttribute}
                      />
                      {/* categories Routes */}
                      <PrivateRoute
                        exact
                        path="/catalogue/categories"
                        component={CategoryList}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/categories/add"
                        component={AddCategory}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/categories/edit/:id"
                        component={AddCategory}
                      />
                      <PrivateRoute
                        exact
                        path="/orders"
                        component={OrderList}
                      />
                      <PrivateRoute
                        exact
                        path="/invoices"
                        component={OrderInvoices}
                      />
                      <PrivateRoute
                        exact
                        path="/order/:id"
                        component={OrderDetails}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/inventory"
                        component={InventoryList}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/import"
                        component={ImportCSV}
                      />
                      <PrivateRoute
                        exact
                        path="/catalogue/excelimport"
                        component={ExcelImport}
                      />
                      {/* Content Routes */}
                      <PrivateRoute
                        exact
                        path="/content/pages"
                        component={ContentPageList}
                      />
                      <PrivateRoute
                        exact
                        path="/content/pages/add"
                        component={AddContentPage}
                      />
                      <PrivateRoute
                        exact
                        path="/content/pages/edit/:id"
                        component={AddContentPage}
                      />
                      <PrivateRoute
                        exact
                        path="/content/news"
                        component={ContentNewsList}
                      />
                      <PrivateRoute
                        exact
                        path="/content/news/add"
                        component={AddNewsPage}
                      />
                      <PrivateRoute
                        exact
                        path="/content/news/edit/:id"
                        component={AddNewsPage}
                      />
                      <PrivateRoute
                        exact
                        path="/content/news/addnewcategory"
                        component={AddNewsCategory}
                      />
                      {/* Variant Routes*/}
                      <PrivateRoute
                        exact
                        path="/catalogue/product/variant/edit/:id"
                        component={EditVariantPage}
                      />
                      {/* Website Templates Routes*/}
                      <PrivateRoute
                        exact
                        path="/templates"
                        component={TemplateList}
                      />
                      <PrivateRoute
                        exact
                        path="/templates/templatedata"
                        component={TemplateData}
                      />
                      <PrivateRoute
                        exact
                        path="/coupons"
                        component={CouponsList}
                      />
                      <PrivateRoute
                        exact
                        path="/coupons/add"
                        component={AddCouponsPage}
                      />
                      <PrivateRoute
                        exact
                        path="/coupons/edit/:id"
                        component={AddCouponsPage}
                      />
                      <PrivateRoute
                        exact
                        path="/report/general"
                        component={GeneralReport}
                      />
                      <PrivateRoute
                        exact
                        path="/customers/customerslist"
                        component={CustomersList}
                      />
                      <PrivateRoute
                        exact
                        path="/customers/newcustomerform"
                        component={NewcustomerForm}
                      />
                      <PrivateRoute exact path="/reviews" component={Reviews} />
                      <PrivateRoute
                        exact
                        path="/mediagallery"
                        component={MediaGallery}
                      />
                      <PrivateRoute
                        exact
                        path="/reviews/:id"
                        component={ReviewsDetail}
                      />
                      <PrivateRoute
                        exact
                        path="/customers/:id"
                        component={CustomersDetail}
                      />
                      <PrivateRoute
                        exact
                        path="/introductionguide"
                        component={IntroductionGuide}
                      />
                      {/* Page Not Found */}
                      <Route path="*">
                        {/* TODO:Add No page found page  */}
                        <PageNotFound />
                      </Route>
                    </Switch>
                  </Suspense>
                </ErrorBoundary>
                <KaiSidekickPanel />
                <SetupGuide />
                </SetupProgressProvider>
                </ImageStudioProvider>
                </KaiContextProvider>
              </ConnectedRouter>
            </Provider>
          );
        }}
      </CacheBuster>
    );
  }
}
